module.exports = __webpack_public_path__ + "img/empty_job_alert.807f6b30.svg";